import { PointLight } from '@anov/3d-core'

class PointLightExt extends PointLight {
  constructor() {
    super()
  }
}

export default PointLightExt